export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "charging": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cargando información del contenedor..."])}
        }
      },
      "en": {
        "labels": {
          "charging": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loading information..."])}
        }
      }
    }
  })
}